import { resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";

var _hoisted_1 = /*#__PURE__*/_createVNode("span", null, "Loading... Please wait 1s.", -1);

var _hoisted_2 = /*#__PURE__*/_createVNode("hr", null, null, -1);

var _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "Loading... Please wait 2s.", -1);

var _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1);

var _hoisted_5 = {
  key: 0
};

var _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "Loading... Please wait 3s.", -1);

var _hoisted_7 = /*#__PURE__*/_createVNode("hr", null, null, -1);

var _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "Loading... Please wait 4s.", -1);

var _hoisted_9 = /*#__PURE__*/_createVNode("h1", null, "I failed to load", -1);

export function render(_ctx, _cache) {
  var _component_MyAsyncComponent = _resolveComponent("MyAsyncComponent");

  var _component_SuspenseWithError = _resolveComponent("SuspenseWithError");

  return _openBlock(), _createBlock(_Fragment, null, [_createVNode(_Suspense, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_MyAsyncComponent, {
        timeout: 1000
      })];
    }),
    fallback: _withCtx(function () {
      return [_hoisted_1];
    }),
    _: 1
  }), _hoisted_2, _createVNode(_Suspense, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_MyAsyncComponent, {
        timeout: 2000
      })];
    }),
    fallback: _withCtx(function () {
      return [_hoisted_3];
    }),
    _: 1
  }), _hoisted_4, _ctx.error ? (_openBlock(), _createBlock("h1", _hoisted_5, "I failed to load")) : _createVNode(_Suspense, {
    key: 1
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_MyAsyncComponent, {
        timeout: 3000,
        "should-fail": ""
      })];
    }),
    fallback: _withCtx(function () {
      return [_hoisted_6];
    }),
    _: 1
  }), _hoisted_7, _createVNode(_component_SuspenseWithError, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_MyAsyncComponent, {
        timeout: 4000,
        "should-fail": ""
      })];
    }),
    fallback: _withCtx(function () {
      return [_hoisted_8];
    }),
    error: _withCtx(function () {
      return [_hoisted_9];
    }),
    _: 1
  })], 64
  /* STABLE_FRAGMENT */
  );
}